import { AxiosError } from 'axios'

export const handleAxiosError = (error: AxiosError): string => {
  const msg = (error && (error.response?.data as { detail: string })?.detail) ?? ''
  if (typeof msg === 'object' && msg !== null) {
    return JSON.stringify(msg)
  }
  return msg
}

export const handleAxiosCodeError = (error: AxiosError): number | null => {
  const code = error && error.response?.status
  return code ?? null
}
